import {ContentFeedNode, DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';

export default function serializeContentNode(node: DTNode, newNode: ServerNode) {
  const contentNode = node as ContentFeedNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description || ''),
    configuration: contentNode.configuration,
    contentFeedId: contentNode.contentFeedId,
    strategy: contentNode.strategy,
    contentId: contentNode.contentId,
    outputs: node.outputs.map((output) => ({
      nodeId: output.nodeId,
      id: output.id,
      type: output.type,
    })),
    timezoneSource: contentNode.timezoneSource,
    timeZone: contentNode.timeZone,
    contentSetId: contentNode.contentSetId,
  };
}

